export default __webpack_public_path__ + "static/media/gauge-danger.b82b1200.svg";